module.exports = __webpack_public_path__ + "img/6_97.7b1a51b8.png";